export default /* glsl */`
#define attribute in
#define varying out
#define texture2D texture
#define GL2
#define VERTEXSHADER
`;
